/**
 * Sidebar yeniden organize edildi: 13 ayrı link → 5 ana sekme (Menü,
 * Sipariş, Müşteri, Raporlar, İşletme). Her ana sekme bir "section"
 * sayfasıdır; içeride bu shell ortak tab navigation'ı sunar ve
 * `<Outlet />` ile aktif alt-route'u render eder.
 *
 * Tab tıklaması URL'i değiştirir (NavLink), yani her tab kendine
 * bookmark'lanabilir bir route'a denk gelir. Bu sayede deep-link bozulmaz
 * ve geri/ileri tarayıcı gezinmesi düzgün çalışır.
 */
import { NavLink, Outlet } from "react-router-dom";
import type { ReactNode } from "react";

export interface SectionTab {
  to: string;
  label: string;
  /** index route için true; aksi halde React Router prefix match yapar */
  end?: boolean;
  /** sağda küçük badge (örn. "Pro") */
  badge?: ReactNode;
}

export function SectionShell({
  tabs,
  rightSlot,
}: {
  tabs: SectionTab[];
  /** Sağ tarafa kondrabilecek aksiyon (örn. "Yeni ekle" butonu) */
  rightSlot?: ReactNode;
}) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between border-b">
        <nav className="-mb-px flex gap-1 overflow-x-auto">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
                  isActive
                    ? "border-primary text-primary"
                    : "border-transparent text-muted-foreground hover:border-muted hover:text-foreground"
                }`
              }
            >
              {tab.label}
              {tab.badge}
            </NavLink>
          ))}
        </nav>
        {rightSlot && <div className="pb-2">{rightSlot}</div>}
      </div>
      <Outlet />
    </div>
  );
}
